import Device from 'Faster/model/Device';
import Session from 'Faster/model/Session';
import FasterRequest from 'Faster/network/FasterRequest';
import ServerDate from 'Faster/model/ServerDate';

class CreateDeviceRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_POST;
  private device: Device;
  private session: Session;
  private trackInstall: boolean;
  private ntpLocalTimestamp: Date;

  public constructor(device: Device, session: Session, trackInstall: boolean) {
    this.device = device;
    this.session = session;
    this.trackInstall = trackInstall;
    this.ntpLocalTimestamp = ServerDate.now();
  }

  public body(): object {
    return {
      deviceId: this.device.id,
      sessionId: this.session.id,
      trackInstall: this.trackInstall,
      platform: this.device.platform,
      system: this.device.system,
      systemVersion: this.device.systemVersion,
      manufacturer: this.device.manufacturer,
      deviceModel: this.device.deviceModel,
      appVersion: this.device.appVersion,
      sdkVersion: this.device.sdkVersion,
      vendorId: this.device.vendorId,
      advertisingId: this.device.advertisingId,
      pushToken: this.device.pushToken,
      cloudId: this.device.cloudId,
      carrierId: this.device.carrierId,
      timezone: this.device.timezone,
      language: this.device.language,
      deviceProperties: this.device.properties,
      localTimestamp: this.session.startedAt,
      ntpLocalTimestamp: this.ntpLocalTimestamp,
    };
  }

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint = (): string => '/v1/device';

  public query = (): string => '';
}

export default CreateDeviceRequest;
